import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileKindSelect',
  props: {
    value: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ["input"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var _useNuxtApp = useNuxtApp(),
      $i18n = _useNuxtApp.$i18n;
    var impactProfileOptions = computed(function () {
      return $i18n.t('impactGoal.impactSolutions.impactSolution.ghgSavingPotentialTool.impactProfile.impactProfiles');
    });
    return {
      __sfc: true,
      props: props,
      emit: emit,
      $i18n: $i18n,
      impactProfileOptions: impactProfileOptions
    };
  }
});